import { connect } from 'react-redux'
import { pageToggleLeft } from 'redux/actions'
import DealCompareFilter from 'pages/mwdealcompare/Left'

const mapStateToProps = state => ({
  isLimitedAccess: state.user.isLimitedAccess
})

const mapDispatchToProps = dispatch => ({
  pageToggleLeft: force => dispatch(pageToggleLeft(force))
})

export default connect(mapStateToProps, mapDispatchToProps)(DealCompareFilter)
